import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DistributionInitComponent } from './distribution-init.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [DistributionInitComponent],
  exports: [DistributionInitComponent]
})
export class DistributionInitModule {}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/distribution-init/distribution-init.module.ts